import { useSelector } from 'react-redux';
import { getUsersAsArray, getUsersCollection } from '.';

export const useUsers = () => useSelector(getUsersCollection);
export const useUsersList = () => useSelector(getUsersAsArray);
